import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "d-flex align-center mb-8" }
const _hoisted_4 = { class: "d-flex align-center" }
const _hoisted_5 = { class: "ml-4" }
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = { class: "mr-2" }
const _hoisted_8 = { class: "my-4" }
const _hoisted_9 = { class: "my-8" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "d-flex mb-1" }
const _hoisted_12 = { class: "nap-grid-container" }
const _hoisted_13 = { class: "nap-grid" }
const _hoisted_14 = { class: "nap-grid-col wide fixed-left" }
const _hoisted_15 = { class: "nap-gird-info nap-grid-header" }
const _hoisted_16 = { class: "col-childName header-cell" }
const _hoisted_17 = { class: "col-className header-cell" }
const _hoisted_18 = { class: "col-status header-cell" }
const _hoisted_19 = { class: "col-childName cell" }
const _hoisted_20 = { class: "col-className cell" }
const _hoisted_21 = { class: "nap-grid-header col" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = ["innerHTML", "onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "pa-4" }
const _hoisted_27 = { class: "d-flex my-8" }
const _hoisted_28 = { class: "d-flex my-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_nap_detail_air_condition_container = _resolveComponent("nap-detail-air-condition-container")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_slide_group_item = _resolveComponent("v-slide-group-item")!
  const _component_v_slide_group = _resolveComponent("v-slide-group")!
  const _component_nap_detail_data_create_container = _resolveComponent("nap-detail-data-create-container")!
  const _component_nap_detail_data_edit_container = _resolveComponent("nap-detail-data-edit-container")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_ctx.nap)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_btn, {
            color: "grey",
            variant: "text",
            to: "/nap/list"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('nap.backToList')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", null, [
          (_ctx.isUpdating)
            ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                key: 0,
                indeterminate: "",
                color: "primary",
                class: "my-8"
              }))
            : _createCommentVNode("", true)
        ]),
        _cache[11] || (_cache[11] = _createElementVNode("div", null, null, -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.$t('nap.napCheck')), 1),
              _createElementVNode("div", _hoisted_5, [
                (_ctx.napStatus === 'inProgress')
                  ? (_openBlock(), _createBlock(_component_v_chip, {
                      key: 0,
                      dark: "",
                      color: "#EE6190"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('nap.status.inProgress')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.napStatus === 'finished')
                  ? (_openBlock(), _createBlock(_component_v_chip, {
                      key: 1,
                      dark: "",
                      color: "#029ec0"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('nap.status.finished')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("h2", null, _toDisplayString(_ctx.subTitle), 1)
          ]),
          _createVNode(_component_v_spacer),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_ctx.napStatus === 'inProgress')
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    size: "large",
                    variant: "flat",
                    color: "primary",
                    disabled: _ctx.isUpdating,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateNapStatus('finished')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('nap.endNap')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true),
              (_ctx.napStatus === 'finished')
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 1,
                    size: "large",
                    variant: "flat",
                    color: "primary",
                    disabled: _ctx.isUpdating,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateNapStatus('inProgress')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('nap.resumeNap')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true),
              (_ctx.napStatus === 'applied')
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 2,
                    size: "large",
                    variant: "flat",
                    color: "primary",
                    disabled: _ctx.isUpdating,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateNapStatus('finished')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('nap.withdrawApplication')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_v_menu, { location: "bottom" }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_btn, _mergeProps({
                  color: "grey",
                  variant: "text"
                }, props, {
                  rounded: "pill",
                  size: "large"
                }), {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                        _createTextVNode("mdi-dots-horizontal", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 16)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_list, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item, {
                      onClick: _cache[3] || (_cache[3] = () => _ctx.isDeleteModalOpen = true)
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, { class: "text-red" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode(_component_v_divider, { class: "my-8" }),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_v_row, { align: "center" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                variant: "outlined",
                "hide-details": "",
                label: _ctx.$t('nap.comment'),
                modelValue: _ctx.comment,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.comment) = $event)),
                disabled: _ctx.isUpdating
              }, null, 8, ["label", "modelValue", "disabled"]),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                color: "primary",
                variant: "flat",
                size: "large",
                disabled: _ctx.isUpdating,
                onClick: _ctx.saveNap
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_nap_detail_air_condition_container),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "3" }, {
                default: _withCtx(() => [
                  _createElementVNode("h4", _hoisted_10, _toDisplayString(_ctx.$t('nap.recorder')), 1),
                  _createVNode(_component_v_select, {
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "",
                    items: _ctx.staffOptions,
                    "item-value": "userId",
                    "item-title": "name",
                    modelValue: _ctx.recorder,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.recorder) = $event))
                  }, null, 8, ["items", "modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "9" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_chip, {
                      size: "small",
                      color: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('attendance.selectTime')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_spacer)
                  ]),
                  _createVNode(_component_v_slide_group, {
                    modelValue: _ctx.selectedHour,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedHour) = $event)),
                    "show-arrows": "",
                    class: "mb-4"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hours, (h) => {
                        return (_openBlock(), _createBlock(_component_v_slide_group_item, {
                          key: h,
                          value: h
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              size: "small",
                              color: "primary",
                              style: {"border-radius":"0px"},
                              variant: _ctx.selectedHour === h ? 'flat' : 'outlined',
                              onClick: ($event: any) => (_ctx.selectedHour = h)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(h), 1)
                              ]),
                              _: 2
                            }, 1032, ["variant", "onClick"])
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('attendance.childName')), 1),
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('common.class')), 1),
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('common.status')), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.napData, (data) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "nap-gird-info",
                  key: data.child.childId
                }, [
                  _createElementVNode("div", _hoisted_19, _toDisplayString(data.child.lastName) + " " + _toDisplayString(data.child.firstName), 1),
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.getCurrentClassName(data.child)), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass(['col-status', 'cell', `${_ctx.getLatestStatus(data.overviews)}`])
                  }, _toDisplayString(_ctx.getLatestStatusLabel(data.overviews)), 3)
                ]))
              }), 128))
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataCols, (hour, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "nap-grid-col",
                key: i
              }, [
                _createElementVNode("div", _hoisted_21, _toDisplayString(hour), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.napData, (data) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "nap-grid-item cell",
                    key: data.child.childId
                  }, [
                    (_ctx.getNapDataStatus(data, hour))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.getNapDataStatus(data, hour).isIcon)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "col-data-cell-event",
                                style: _normalizeStyle(`color: ${_ctx.getNapDataStatus(data, hour).color}; background-color: ${_ctx.getNapDataStatus(data, hour).bg};`),
                                onClick: ($event: any) => (_ctx.cellClickEdit(data, hour))
                              }, [
                                _createVNode(_component_v_icon, { color: "white" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.getNapDataStatus(data, hour).iconName), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createElementVNode("div", {
                                  innerHTML: _ctx.getNapDataStatus(data, hour).label
                                }, null, 8, _hoisted_23)
                              ], 12, _hoisted_22))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "col-data-cell-event",
                                style: _normalizeStyle(`color: ${_ctx.getNapDataStatus(data, hour).color}; background-color: ${_ctx.getNapDataStatus(data, hour).bg};`),
                                innerHTML: _ctx.getNapDataStatus(data, hour).label,
                                onClick: ($event: any) => (_ctx.cellClickEdit(data, hour))
                              }, null, 12, _hoisted_24))
                        ], 64))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "col-data-cell-event",
                          onClick: ($event: any) => (_ctx.cellClickCreate(data.child.childId, hour))
                        }, [
                          _createVNode(_component_v_icon, { color: "grey" }, {
                            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                              _createTextVNode("mdi-plus", -1)
                            ]))]),
                            _: 1
                          })
                        ], 8, _hoisted_25))
                  ]))
                }), 128))
              ]))
            }), 128))
          ])
        ]),
        _createVNode(_component_nap_detail_data_create_container),
        _createVNode(_component_nap_detail_data_edit_container),
        _createVNode(_component_v_dialog, {
          modelValue: _ctx.isDeleteModalOpen,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isDeleteModalOpen) = $event)),
          "max-width": "540"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_v_spacer),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('nap.confirmDeleteNap')) + " ", 1),
                    _createVNode(_component_v_spacer)
                  ]),
                  _createElementVNode("div", null, [
                    (_ctx.isDeleting)
                      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                          key: 0,
                          indeterminate: "",
                          color: "red",
                          class: "my-8"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      variant: "flat",
                      color: "grey",
                      class: "mr-2",
                      size: "large",
                      dark: "",
                      onClick: _cache[7] || (_cache[7] = () => _ctx.isDeleteModalOpen = false)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      variant: "flat",
                      color: "red",
                      size: "large",
                      onClick: _ctx.deleteNap,
                      dark: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_v_spacer)
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]))
    : _createCommentVNode("", true)
}